module.exports = __webpack_public_path__ + "img/阳台推拉门.3d01e6c2.webp";